import React from "react";
import { Link, useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./Item.module.sass";
import { markNotificationAsRead } from "../../../../services/notification.service";

// Fonction pour formater le temps (identique à celle de l'autre composant Item)
const formatTime = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const now = new Date();
  const seconds = Math.floor((now - date) / 1000);

  let interval = seconds / 31536000;
  if (interval > 1) return `${Math.floor(interval)}a`;
  interval = seconds / 2592000; 
  if (interval > 1) return `${Math.floor(interval)}m`;
  interval = seconds / 86400;
  if (interval > 1) return `${Math.floor(interval)}j`;
  interval = seconds / 3600;
  if (interval > 1) return `${Math.floor(interval)}h`;
  interval = seconds / 60;
  if (interval > 1) return `${Math.floor(interval)}m`;
  return `${Math.floor(seconds)}s`;
};

const Item = ({ className, item, onClose }) => {
  const navigate = useNavigate();
  const imagePath = `/images/content/${item.icon}`;
  
  const handleClick = async (e) => {
    if (e) e.preventDefault();
    
    // Marquer la notification comme lue si ce n'est pas déjà fait
    if (!item.read) {
      try {
        await markNotificationAsRead(item.id);
      } catch (error) {
        console.error('Erreur lors du marquage de la notification comme lue:', error);
      }
    }
    
    // Fermer le menu de notifications
    if (onClose) onClose();
    
    // Naviguer vers le lien
    if (item.link) {
      setTimeout(() => navigate(item.link), 50);
    }
  };
  
  return (
    <div 
      className={cn(styles.item, { [styles.new]: !item.read }, className)}
      onClick={handleClick}
      style={{ cursor: 'pointer' }}
    >
      <div className={styles.avatar}>
        <img src={imagePath} alt={item.title} />
      </div>
      <div className={styles.details}>
        <div className={styles.line}>
          <div className={styles.subtitle}>{item.title}</div>
          <div className={styles.time}>{formatTime(item.created)}</div>
        </div>
        <div className={styles.content}>{item.message}</div>
      </div>
    </div>
  );
};

export default Item;
